import { Controller } from "@hotwired/stimulus"

// Controller for showing/hiding saving spinners on question badges
// All other progress tracking (badges, percentages, etc.) is handled by backend + Turbo streams
export default class extends Controller {
  static targets = ["questionItem"]

  // Minimum duration (in ms) to show the saving spinner
  // Prevents spinner from flashing too quickly on fast saves
  static SPINNER_MIN_DURATION = 500

  connect() {
    // Track spinner show times for minimum display duration
    this.spinnerShowTimes = new Map()
  }

  // Show saving spinner on a specific question badge
  showQuestionSaving(questionId) {
    const questionItem = this.questionItemTargets.find(item => item.dataset.questionId === questionId.toString())
    if (!questionItem) return

    const questionHeader = questionItem.querySelector('.question-header')
    if (!questionHeader) return

    // Find the badge container (has d-flex, align-items-center, gap-2 classes)
    const badgeContainer = questionHeader.querySelector('.d-flex.align-items-center.gap-2')
    if (!badgeContainer) return

    // Don't add spinner if already present
    if (badgeContainer.querySelector('[data-saving-spinner="true"]')) return

    // Create spinner element to the left of badges
    const spinner = document.createElement('i')
    spinner.className = 'fas fa-spinner fa-spin text-primary'
    spinner.dataset.savingSpinner = 'true'
    spinner.dataset.questionId = questionId.toString()

    // Insert spinner as first child (to the left of badges)
    badgeContainer.insertBefore(spinner, badgeContainer.firstChild)

    // Track when spinner was shown for minimum display duration
    this.spinnerShowTimes.set(questionId.toString(), Date.now())
  }

  // Hide saving spinner from a specific question badge
  hideQuestionSaving(questionId) {
    const questionItem = this.questionItemTargets.find(item => item.dataset.questionId === questionId.toString())
    if (!questionItem) return

    const questionHeader = questionItem.querySelector('.question-header')
    if (!questionHeader) return

    const badgeContainer = questionHeader.querySelector('.d-flex.align-items-center.gap-2')
    if (!badgeContainer) return

    const spinner = badgeContainer.querySelector(`[data-saving-spinner="true"][data-question-id="${questionId}"]`)
    if (!spinner) return

    // Calculate how long spinner has been shown
    const showTime = this.spinnerShowTimes.get(questionId.toString())
    const elapsed = showTime ? Date.now() - showTime : 0
    const remaining = Math.max(0, this.constructor.SPINNER_MIN_DURATION - elapsed)

    // Wait for minimum duration before hiding
    setTimeout(() => {
      spinner.remove()
      this.spinnerShowTimes.delete(questionId.toString())
    }, remaining)
  }

}
